import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DataService } from 'app/services/data.service';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { ToastService } from '../toasts/toasts.service';

@Component({
  selector: 'app-news-column',
  templateUrl: './news-column.component.html',
  styleUrls: ['./news-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsColumnComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public height: string;
  @Input() public data: Observable<any> = null;
  public loading: boolean = true;
  private dataSubcription: Subscription;
  constructor(private cd: ChangeDetectorRef, private dataService: DataService, private _toastService: ToastService) { }

  ngOnInit(): void {
    // console.log(this.data);
  }

  ngAfterViewInit(): void {
    this.dataSubcription = this.data.subscribe((data)=>{
      if(data && typeof(data) !== 'string'){
        this.loading = false;
        this.cd.detectChanges();
      } else {
        console.log(data);
        this.loading = true;
        this.cd.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.dataSubcription.unsubscribe();
  }

  addnews(news:any){
    const news_data = {
      title: news.title,
      url: news.article_url,
      recordedOn: moment().format('MM/DD/YYYY')
    };
    this.dataService.addUserNews(news_data).subscribe((result)=>{
      this._toastService.show(`News Added`, {
        delay: 2000,
        classname: 'bg-success text-light',
        autohide: true
      });
    });
  }

}
